import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import {
  WorkflowVertexGroupSpecification,
  WorkflowVertexLibrary,
  WorkflowVertexSpecification
} from 'component.workflow.core';


@Component({
  selector: 'wf-vertex-library',
  template: `

    <section *ngFor="let group of groups">
      <h3>{{ group.name }}</h3>
      <p>{{ group.description }}</p>
      <div class="collection">
        <wf-vertex-library-item *ngFor="let vertex of group.vertices" (click)="clicked.emit(vertex)"
                                [vertex]="vertex"></wf-vertex-library-item>
      </div>

    </section>

  `,
  styles: [ `
    section:first-child h3 {
      margin-top: 0;
    }

    .collection {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-row-gap: 0.75rem;
      justify-items: stretch;
    }

  ` ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowVertexLibraryComponent {
  library: WorkflowVertexLibrary;

  @Output() clicked = new EventEmitter<WorkflowVertexSpecification>();

  constructor() {
    // We need to show small sized items so need a small size definition.
    this.library = new WorkflowVertexLibrary(35);
  }

  get groups(): WorkflowVertexGroupSpecification[] {
    return this.library.getSpecifications();
  }
}



// WEBPACK FOOTER //
// ./src/library/vertex-library/workflow-vertex-library.component.ts